import styled from 'styled-components';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const ShareContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  height: initial;
  ${media.mediumDesktop`
    margin-top: auto;
    height: unset;
    justify-content: flex-end;
  `}
`;
export const ShareIcons = styled.div`
  display: flex;
  flex-direction: row;
`;
export const SocialIcon = styled.div.attrs(() => ({
  tabIndex: 0,
  type: 'button',
}))`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 0.25rem;

  &:hover {
    background: ${colors.pacificBlue};
    & svg {
      color: ${colors.white} !important;
    }
  }
  ${media.mediumDesktop`
    margin: 0 0.25rem;
  `}
`;
